import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addActionsToStaff,
  setSelectedStaff,
  setOnConfirmDelete,
  setDeleteId,
  setConfirmText,
} from "../reducers/companyStaff";

interface Action {
  name: string;
  action: (staff: any) => void;
}

interface ActionsButtonProps {
  actionList: Action[];
  staff: any;
}

const ActionsButton: React.FC<ActionsButtonProps> = ({ actionList, staff }) => {
  const [open, setOpen] = useState(false);
  const [disabledDelete, setDisabledDelete] = useState(false);
  const currentUser = useSelector((state: any) => state.currentUser);
  
  useEffect(() => {
    if (currentUser.staffInfo.id === staff.id) {
      setDisabledDelete(true);
    } else {
      setDisabledDelete(false);
    }
  }, [currentUser, staff.id]);

  const handleSelect = (action: any) => {
    action.action();
    setOpen(false);
  };

  const handleBlur = (event: any) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setOpen(false);
    }
  };

  const dispatch = useDispatch();
  const staffList = useSelector((state: any) => state.companyStaff.staffList);

  useEffect(() => {
    dispatch(addActionsToStaff());
  }, [dispatch]);
  const handleEditClick = (staff: any) => {
    setOpen(false);
    dispatch(setSelectedStaff(staff));
    dispatch(setOnConfirmDelete(false));
  };

  const handleDeleteClick = (staff: any) => {
    dispatch(setDeleteId(staff.id));
    setOpen(false);
    dispatch(setOnConfirmDelete(true));
    const htmlContent = "<h1>Are you sure you want to delete this item?</h1>";
    dispatch(
      setConfirmText(
        <>
          <p>
            {staff.last_name} {staff.first_name} を管理ユーザーから削除します。
            <br />
            よろしいですか？
          </p>
        </>,
      ),
    );
  };

  const handleItemClick = (actionObj: any) => {
    if (disabledDelete) return;
    if (actionObj.name === "編集") {
      handleEditClick(staff);
    } else {
      handleDeleteClick(staff);
    }
  };

  return (
    <div className="relative" onBlur={handleBlur} tabIndex={-1}>
      <button onClick={() => setOpen(true)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_8575_19614)">
            <path
              d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
              fill="#343A3D"
            />
          </g>
          <defs>
            <clipPath id="clip0_8575_19614">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      {open && (
        <ul className="min-w-max z-[99] absolute py-1 rounded-lg top-2 right-[100%] bg-white alu-options-box-shadow flex flex-col">
          {actionList.map((actionObj, idx) => (
            <li
              tabIndex={0}
              key={idx}
              onClick={() => handleItemClick(actionObj)}
              className={`px-6 py-2 rounded text-sm leading-[1.3125rem] ${disabledDelete ? "text-[#BBBBBB] bg-[#F4F4F4]" : "alu-text-base-2 hover:cursor-pointer hover:bg-[#FFF3E5]"} flex items-center justify-center`}
            >
              {actionObj.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActionsButton;
